export const concat = (chaine: string|null, chaineToAdd: string|null,separator:string="<br/>") => {
  return (chaine && chaine.length > 0)?
            ((chaineToAdd && chaineToAdd.length > 0)?`${chaine}${separator}${chaineToAdd}`:chaine)
            :chaineToAdd??''
}